import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { useTheme } from './store/theme'
import './index.css'

// Applied before the first render rather than in an effect. Effects run
// children-first, so a screen that pins light — sign-in, the marketing page —
// would otherwise be overridden a moment later by the app restoring the saved
// preference. Doing it here also avoids a flash of the wrong theme.
useTheme.getState().restore()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
